// "Load Values" from a linked partner location, including individual header
// sub-keys addressed with dot-notation.

import { parseAttributeKey, setHeaderValue } from '../../features/dynamic-form';

// Values offered by a linked shared setting arrive either as a whole attribute
// or as dot-notated header sub-keys ('headers1.KarmakAccountNumber') that patch
// a single entry inside an existing headers attribute.
const valueFor = (name, currentValue, attributesToLoad) => {
  const exactMatch = attributesToLoad.find((a) => a.name === name);
  if (exactMatch) return exactMatch.value;

  const headerEntries = attributesToLoad.filter((a) => {
    const { baseName, subKey } = parseAttributeKey(a.name);
    return baseName === name && subKey !== null;
  });

  if (headerEntries.length === 0) return undefined;

  let updatedHeaders = Array.isArray(currentValue) ? [...currentValue] : [];

  headerEntries.forEach(({ name: dotName, value }) => {
    const { subKey } = parseAttributeKey(dotName);
    updatedHeaders = setHeaderValue(updatedHeaders, subKey, value);
  });

  return updatedHeaders;
};

// Only the fields the shared setting actually changes, keyed by name.
export const linkedSourceValues = (values, attributesToLoad) =>
  Object.keys(values).reduce((acc, name) => {
    const next = valueFor(name, values[name], attributesToLoad);
    return next === undefined ? acc : { ...acc, [name]: next };
  }, {});
